<router-outlet></router-outlet>
@if (uiService.isMiniCartVisible$ | async) {
  <app-mini-cart></app-mini-cart>
}
<app-quick-view></app-quick-view>
<app-auth-modal></app-auth-modal>
